<template>
  <component
    :is="listStyle === 'number' ? 'ol' : 'ul'"
    :class="['zg-usps', {
      [`zg-usps--direction-${direction}`]: direction,
      'zg-usps--small-gap': smallGap
    }]"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
    >
      <div
        :class="['icon', {
          [`icon--${listStyle}`]: listStyle
        }]"
      >
        <zg-icon
          v-if="listStyle === 'check'"
          icon="check"
          size="small"
        />

        <span
          v-else-if="listStyle === 'number'"
          class="number"
        >
          {{ index + 1 }}.
        </span>

        <span
          v-else-if="listStyle === 'bullet'"
          class="bullet"
        >
          <span />
        </span>
      </div>

      <div class="content">
        <span
          v-if="item.title"
          class="title"
        >
          {{ item.title }}
        </span>

        <span
          v-if="item.description"
          class="description"
        >
          {{ item.description }}
        </span>
      </div>
    </li>
  </component>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgUsps',
    components: {
      ZgIcon
    },
    props: {
      usps: {
        type: Array,
        required: true,
        validator: usps => Array.isArray(usps) && usps.length > 0
      },
      direction: {
        type: String,
        required: false,
        default: 'horizontal',
        validator: (value) => ['horizontal', 'vertical'].includes(value)
      },
      listStyle: {
        type: String,
        required: false,
        default: 'check',
        validator: (value) => ['check', 'number', 'bullet'].includes(value)
      },
      smallGap: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      items () {
        if (typeof this.usps?.[0] === 'object') return this.usps

        return this.usps?.map(item => ({ description: item }))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-usps {
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    flex-wrap: wrap;
    list-style: none;
    margin: rhythm(xsmall) 0;

    li {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: row;
      gap: rem(8px);
      list-style: none;

      ::v-deep .zg-icon--small {
        width: 20px;
        height: 20px;
      }

      .icon {
        height: 100%;

        &--check {
          width: rem(20px);
        }
      }

      .content {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: rem(8px);
      }

      span {
        &.bullet {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          & > span {
            width: rem(4px);
            height: rem(4px);
            background-color: color(black);
            border-radius: 99%;
          }
        }

        &.title,
        &.number {
          @include type-title-xs;

          margin: 0;
        }

        &.description {
          @include type-body-s;

          margin: 0;
        }
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // direction
  // ? ----------------------------------------------------------------------

  .zg-usps--direction-horizontal {
    flex-flow: row;
    gap: rem(24px);
  }

  .zg-usps--direction-vertical {
    flex-flow: column;
    gap: rem(6px);
  }

  // ? ----------------------------------------------------------------------
  // size
  // ? ----------------------------------------------------------------------

  .zg-usps--small-gap {
    gap: 0;
  }
</style>
